import { render } from "./FlyoutMenuItem.vue?vue&type=template&id=a2220f64&scoped=true"
import script from "./FlyoutMenuItem.vue?vue&type=script&lang=js"
export * from "./FlyoutMenuItem.vue?vue&type=script&lang=js"

import "./FlyoutMenuItem.vue?vue&type=style&index=0&id=a2220f64&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2220f64"]])

export default __exports__